import React from 'react';

//
import MainTitle from '../../components/page/main-title/MainTitle';
import WS from '../../config/Ws';
import Requisitions from '../../utils/requisitions/Requisitions';
import './page.css';
import Dialog from '../../components/alert/Dialog';
import STRINGS from './../../data/language/language';
import Modal from '../../components/modal.v2/Modal';
import Detail from './Detail';
import ButtonAdd from '../../components/form/ButtonAdd';

const URL = WS.medidas;

class Page extends React.Component{
  constructor (props){
    super(props);

    this.state = {
      strings:STRINGS[window.LANGUAGE],
      loaded: false,
      lista: [
        {
          id:1, data:'06/04/2019', peso: 60
        },
        {
          id:1, data:'06/03/2019', peso: 70
        },
        {
          id:1, data:'06/02/2019', peso: 75
        },
        {
          id:1, data:'06/01/2019', peso: 80
        }
      ],
      loaded: true
    };

    this.openDetail = this.openDetail.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  componentDidMount() {
    //dá um scroll no window pois quando carregamos uma nova tela
    //se a anterior tivesse sido rolada para baixo a página ficava na posição errada no topo
    window.scrollTo(0, 0);

    const {atencao} = this.state.strings;
    let _self = this;

    /*Requisitions({
      url: URL.lista,
      data: {},
      sucess:function(data){
        var msg;

        if(data.status){
          _self.setState({
            lista: data.data.lista,
            loaded: true
          });
        }else{
          msg = {
            title: atencao,
            text: data.msg
          };
          Dialog.create(msg);
        }
        _self.setState({
          isLoading: false
        });
      },
      error:function(data){
        console.log(data);
      }
    });*/
  }

  openDetail(e, id) {
    const {atencao} = this.state.strings;
    let _self = this;
    const history = this.props.history;
    Modal.create({
      content: <Detail history={history} data={{}} />
    });
    /*Requisitions({
      url: URL.detalhe,
      data: { id },
      sucess:function(data){
        var msg;

        if(data.status){
          Modal.create({
            content: <Detail history={history} data={data.data} />
          });
        }else{
          msg = {
            title: atencao,
            text: data.msg
          };
          Dialog.create(msg);
        }
        _self.setState({
          isLoading: false
        });
      },
      error:function(data){
        console.log(data);
      }
    });*/

    e.preventDefault();
  }

  getThumb(value) {

    return(
      <div className='medida-thumb'>
        <table>
          <tbody>
            <tr>
              <td>
                <img src={value.thumb} />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }

  getView() {
    const self = this;

    let lista = this.state.lista.map((value, i) =>
        {
          const thumb = value.thumb ? self.getThumb(value) : '';
          const thumbClass = value.thumb ? 'medida-with-thumb' : '';

          return(
            <a href="#" key={i} className={`${thumbClass} link-detail`} onClick={(e) => this.openDetail(e,value.id)}>
              {thumb}
              <div className='data-medida'>{value.data}</div>
              <div className='medida-peso'>{`${value.peso}kg`}</div>
              <i className="fas fa-chevron-right"></i>
            </a>
          );
        }
      );

    return lista;
  }

  handleClick (e){
    const history = this.props.history;
    Modal.create({
      content: <Detail history={history} />
    });

    //ao clicar no botão ao apertar enter o handleclick era chamado, o blur previne que ele seja chamado sempre
    document.activeElement.blur();

    e.preventDefault();
  }

  render() {
    const view = this.state.loaded ? this.getView() : null;
    return (
      <div className="page-dashboard page-content" >
        <ButtonAdd myClick={this.handleClick}></ButtonAdd>
        <div className="container">
          <div className="container-box">
            <div className="container-box--inner">
              <MainTitle title="Minhas medidas"></MainTitle>
              <div>
                {view}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Page;



// WEBPACK FOOTER //
// ./src/classes/medidas/Page.js